import axiosInstance from './api'; 

export const getAllCategories = () => axiosInstance.get('/category');
export const createCategory = (name) => axiosInstance.post('/category', { name });
export const updateCategory = (id, name) => axiosInstance.put(`/category/${id}`, { name });
export const deleteCategory = (id) => axiosInstance.delete(`/category/${id}`);

export const importCategoriesFromExcel = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axiosInstance.post('/category/import-excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};